
import Vue from 'vue';
import { CheckoutPaymentData } from './checkoutPayment.vue';
import { Component, Prop } from '@modules/vue-property-decorator';
import InputText from '@shared/components/form/inputText.vue';
import InputPassword from '@shared/components/form/inputPassword.vue';
import Navigation from '@shared/components/navigation/navigation.vue';

@Component({
    components: {
        InputText,
        InputPassword,
        Navigation,
    },
})
export default class CheckoutForm extends Vue {
  @Prop({ required: true }) private data!: CheckoutPaymentData;
  private errors: any = {};
  private reloadErrors: number = 0;

  private get isLoggedIn(): boolean {
    return this.$store.state.loggedIn;
  }

  private onSubmit() {
    this.cleanErrors();
    if (!this.checkErrors()) {
      this.reloadErrors++;
      return;
    }
    this.$emit('next');
  }
  private cleanErrors() {
    this.errors = {};
  }
  private checkErrors(): boolean {
    let isOk = true;
    if (this.data.password !== this.data.password2) {
      this.errors.password2 = this.$t("Password does not match");
      this.errors.password1 = this.$t("Password does not match");
      isOk = false;
    }
    return isOk;
  }
}
